import { NgModule, Optional, SkipSelf, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Http } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap';

// translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { createTranslateLoader } from '../factories/leaf.translate.factory';

import { LeafFrameworkShared } from './leaf-framework.shared.module';

// layout
import { MinimalizeComponent } from '../layout/minimalize.component';
import { NavComponent } from '../layout/nav.component';
import { NavUserItemComponent } from '../components/nav-user-item/nav-user-item.component';
import { NavSearchInputComponent } from '../components/nav-search-input/nav-search-input.component';
import { NavSearchEmployeeResultTypeComponent } from '../components/nav-search-input/result-types/employee-result-type.component';
import { FooterComponent } from '../layout/footer.component';
import { HeaderComponent } from '../layout/header.component';
import { ControlMessagesComponent } from '../layout/control-messages.component';
import { PageNotFoundComponent } from '../layout/not-found.component';
import { ModalMessageComponent } from '../components/modal-message/modal-message.component';
import { MessageService } from '../components/modal-message/message.service';

import { SpinnerComponent } from '../components/spinner/spinner.component';
import { SpinnerService } from '../components/spinner/spinner.service';

import { ApplicationChangerComponent } from '../components/application-changer/application-changer.component';
import { LanguageSelectorComponent } from '../components/language-selector/language-selector.component';
import { LanguageService } from '../components/language-selector/language.service';

import { ValidationService } from '../services/validation.service';

import { MenuService } from '../layout/menu.service';
import { AuthGuard } from '../guards/auth.guard';
import { LoginGuard } from '../guards/login.guard';
import { AuthHelper } from '../services/auth.helper';
import { throwIfAlreadyLoaded } from '../guards/module-import.guard';



export class LeafFrameworkCore {
  constructor(   parentModule: LeafFrameworkCore) {
    throwIfAlreadyLoaded(parentModule, 'LeafFrameworkCore');
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [ LeafFrameworkShared,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }
  })
],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavComponent,
    NavUserItemComponent,
    NavSearchInputComponent,
    NavSearchEmployeeResultTypeComponent,
    MinimalizeComponent,
    SpinnerComponent,
    LanguageSelectorComponent,
    ApplicationChangerComponent,
    ModalMessageComponent
  ],
  exports: [
    LeafFrameworkShared,
    HeaderComponent,
    FooterComponent,
    NavComponent,
    NavUserItemComponent,
    NavSearchInputComponent,
    NavSearchEmployeeResultTypeComponent,
    MinimalizeComponent,
    SpinnerComponent,
    LanguageSelectorComponent,
    ApplicationChangerComponent,
    ModalMessageComponent
  ],
  providers: [
    SpinnerService,
    MenuService,
    LanguageService,
    AuthGuard,
    LoginGuard,
    AuthHelper,
    MessageService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LeafFrameworkCore, decorators: [{ type: Optional }, { type: SkipSelf }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
